import React from 'react';

import Button from '@/components/Button';
import { WizardStep } from '@/components/Wizard';
import { appUiIds } from '@/constants/appUiIds';
import useAppUiData from '@/hooks/useAppUiData';

import RichUI from '@/ui-kit/rich-text/RichUI/RichUI';

import styles from './ClaimBookingStep.module.scss';

type ClaimBookingSessionExpiredProps = {
  tabId: string;
  onCancel: () => void;
};

const ClaimBookingSessionExpired = ({ tabId, onCancel }: ClaimBookingSessionExpiredProps) => {
  const appUiData = useAppUiData();

  return (
    <WizardStep tabId={tabId}>
      <div className={styles.lockedContainer}>
        <h2 className={styles.title}>{appUiData[appUiIds.claimBooking.sessionExpiredTitle]}</h2>
        <p className={styles.subtitle}>
          <RichUI code={appUiData[appUiIds.claimBooking.sessionExpiredBody]} useRichText={false} />
        </p>
        <div className={styles.buttonContainer}>
          <Button variant="primary" onClick={onCancel} className={styles.expiredBtn}>
            {appUiData[appUiIds.claimBooking.otpLockedCTA]}
          </Button>
        </div>
      </div>
    </WizardStep>
  );
};

export default ClaimBookingSessionExpired;
